import React from 'react';

export default function AttendanceRegularizationForm({
  state,
  actions,
}) {
  const isReadOnly = state.isView;

  return (
    <form onSubmit={actions.handleSaveAndExit} className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Main Form Fields Card (2 cols) */}
        <div className="lg:col-span-2 space-y-6">
          <div className="rounded-2xl border border-outline-variant/25 bg-surface-container-lowest shadow-xs overflow-hidden">
            {/* Card Header */}
            <div className="border-b border-outline-variant/20 bg-surface-container-low/40 px-6 py-4 flex items-center justify-between">
              <div className="flex items-center gap-2.5">
                <span className="material-symbols-outlined text-primary text-xl">
                  {state.isView ? 'visibility' : 'edit_calendar'}
                </span>
                <h2 className="font-display text-base font-bold text-black">
                  {state.isView
                    ? 'View Attendance Regularization'
                    : state.isEdit
                    ? 'Edit Attendance Regularization'
                    : 'Attendance Regularization'}
                </h2>
              </div>
              <span className="text-xs font-semibold text-slate-500 font-mono">
                {state.editId ? `ID: #${state.editId}` : 'New Request'}
              </span>
            </div>

            {/* Form Inputs */}
            <div className="p-6 space-y-5">
              {/* Name (Read-only) */}
              <div className="grid grid-cols-1 sm:grid-cols-4 items-center gap-2 sm:gap-4">
                <label className="text-xs font-bold text-slate-700 sm:text-right">
                  Name
                </label>
                <div className="sm:col-span-3">
                  <input
                    type="text"
                    value={state.name}
                    readOnly
                    className="w-full rounded-xl border border-outline-variant/30 bg-surface-container-low/60 px-3.5 py-2.5 text-xs font-bold text-black cursor-not-allowed outline-hidden"
                  />
                </div>
              </div>

              {/* Date */}
              <div className="grid grid-cols-1 sm:grid-cols-4 items-center gap-2 sm:gap-4">
                <label className="text-xs font-bold text-slate-700 sm:text-right">
                  Date {!isReadOnly && <span className="text-rose-500">*</span>}
                </label>
                <div className="sm:col-span-3">
                  <input
                    type="date"
                    value={state.date}
                    onChange={(e) => actions.setDate(e.target.value)}
                    disabled={isReadOnly}
                    readOnly={isReadOnly}
                    required={!isReadOnly}
                    className={`w-full rounded-xl border border-outline-variant/30 px-3.5 py-2.5 text-xs font-semibold text-black outline-hidden transition ${
                      isReadOnly
                        ? 'bg-surface-container-low/60 cursor-not-allowed'
                        : 'bg-surface-container-lowest focus:border-primary focus:ring-1 focus:ring-primary'
                    }`}
                  />
                </div>
              </div>

              {/* Time (Hour, Minute, AM/PM) */}
              <div className="grid grid-cols-1 sm:grid-cols-4 items-center gap-2 sm:gap-4">
                <label className="text-xs font-bold text-slate-700 sm:text-right">
                  Time {!isReadOnly && <span className="text-rose-500">*</span>}
                </label>
                <div className="sm:col-span-3 grid grid-cols-3 gap-2.5">
                  {/* Hour */}
                  <select
                    value={state.timeHour}
                    onChange={(e) => actions.setTimeHour(e.target.value)}
                    disabled={isReadOnly}
                    className={`w-full rounded-xl border border-outline-variant/30 px-3 py-2.5 text-xs font-bold text-black outline-hidden transition ${
                      isReadOnly
                        ? 'bg-surface-container-low/60 cursor-not-allowed'
                        : 'bg-surface-container-lowest focus:border-primary cursor-pointer'
                    }`}
                  >
                    {state.hourOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>

                  {/* Minute */}
                  <select
                    value={state.timeMinute}
                    onChange={(e) => actions.setTimeMinute(e.target.value)}
                    disabled={isReadOnly}
                    className={`w-full rounded-xl border border-outline-variant/30 px-3 py-2.5 text-xs font-bold text-black outline-hidden transition ${
                      isReadOnly
                        ? 'bg-surface-container-low/60 cursor-not-allowed'
                        : 'bg-surface-container-lowest focus:border-primary cursor-pointer'
                    }`}
                  >
                    {state.minuteOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>

                  {/* AM / PM */}
                  <select
                    value={state.timeAmPm}
                    onChange={(e) => actions.setTimeAmPm(e.target.value)}
                    disabled={isReadOnly}
                    className={`w-full rounded-xl border border-outline-variant/30 px-3 py-2.5 text-xs font-bold text-black uppercase outline-hidden transition ${
                      isReadOnly
                        ? 'bg-surface-container-low/60 cursor-not-allowed'
                        : 'bg-surface-container-lowest focus:border-primary cursor-pointer'
                    }`}
                  >
                    {state.amPmOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Reason */}
              <div className="grid grid-cols-1 sm:grid-cols-4 items-center gap-2 sm:gap-4">
                <label className="text-xs font-bold text-slate-700 sm:text-right">
                  Reason {!isReadOnly && <span className="text-rose-500">*</span>}
                </label>
                <div className="sm:col-span-3">
                  <select
                    value={state.reason}
                    onChange={(e) => actions.setReason(e.target.value)}
                    disabled={isReadOnly}
                    required={!isReadOnly}
                    className={`w-full rounded-xl border border-outline-variant/30 px-3.5 py-2.5 text-xs font-bold text-black outline-hidden transition ${
                      isReadOnly
                        ? 'bg-surface-container-low/60 cursor-not-allowed'
                        : 'bg-surface-container-lowest focus:border-primary cursor-pointer'
                    }`}
                  >
                    {state.reasonOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Remarks */}
              <div className="grid grid-cols-1 sm:grid-cols-4 items-start gap-2 sm:gap-4">
                <label className="text-xs font-bold text-slate-700 sm:text-right pt-2.5">
                  Remarks {!isReadOnly && <span className="text-rose-500">*</span>}
                </label>
                <div className="sm:col-span-3">
                  <textarea
                    rows={4}
                    value={state.remarks}
                    onChange={(e) => actions.setRemarks(e.target.value)}
                    readOnly={isReadOnly}
                    disabled={isReadOnly}
                    placeholder="Enter reason details (e.g. biometric machine malfunction, client visit details, work from home justification)..."
                    required={!isReadOnly}
                    className={`w-full rounded-xl border border-outline-variant/30 p-3.5 text-xs text-black font-medium outline-hidden transition ${
                      isReadOnly
                        ? 'bg-surface-container-low/60 cursor-not-allowed'
                        : 'bg-surface-container-lowest focus:border-primary'
                    }`}
                  />
                </div>
              </div>
            </div>

            {/* GPS In Section */}
            <div className="border-t border-outline-variant/20 bg-surface-container-low/20 px-6 py-3.5">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span className="material-symbols-outlined text-primary text-base">
                    location_on
                  </span>
                  <span className="text-xs font-bold text-black">GPS In</span>
                  <span className="text-[11px] text-slate-600 font-mono font-medium">
                    ({state.gpsIn})
                  </span>
                </div>
                <span className="inline-flex items-center gap-1 rounded-md bg-emerald-50 px-2 py-0.5 text-[10px] font-bold text-emerald-700 border border-emerald-200">
                  <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                  Verified
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* TIPS Sidebar Card */}
        <div className="space-y-6">
          <div className="rounded-2xl border border-outline-variant/25 bg-surface-container-lowest p-6 shadow-xs">
            <div className="flex items-center gap-2 border-b border-outline-variant/20 pb-3">
              <span className="material-symbols-outlined text-amber-500 text-lg">
                lightbulb
              </span>
              <h3 className="font-display text-sm font-extrabold tracking-wide uppercase text-black">
                TIPS
              </h3>
            </div>
            <ul className="mt-4 space-y-3 text-xs text-slate-800">
              <li className="flex items-start gap-2">
                <span className="text-primary font-bold mt-0.5">•</span>
                <span>
                  Employees Use this feature to enter <strong>MisPunches (Intime/Outtime)</strong>.
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary font-bold mt-0.5">•</span>
                <span>
                  Regularization requests are directly routed to your reporting manager for approval.
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary font-bold mt-0.5">•</span>
                <span>
                  Please ensure accurate remarks are provided for faster request processing.
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary font-bold mt-0.5">•</span>
                <span>
                  GPS location is automatically recorded upon submission for validation.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Sticky Actions Toolbar */}
      <div className="flex items-center justify-end gap-3 border-t border-outline-variant/20 bg-surface-container-lowest p-4 rounded-2xl shadow-xs">
        {isReadOnly ? (
          /* View Mode: Only Cancel button matching screenshot */
          <button
            type="button"
            onClick={actions.handleCancel}
            className="rounded-xl border border-outline-variant/40 bg-surface-container-lowest px-5 py-2 text-xs font-bold text-slate-800 hover:bg-surface-container-high transition cursor-pointer shadow-xs"
          >
            Cancel
          </button>
        ) : (
          /* Edit / New Mode */
          <>
            <button
              type="button"
              onClick={actions.handleCancel}
              className="rounded-xl border border-outline-variant/40 bg-surface-container-lowest px-4 py-2 text-xs font-bold text-slate-700 hover:bg-surface-container-high transition cursor-pointer"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={actions.handleSaveAndContinue}
              disabled={state.isSaving}
              className="rounded-xl border border-outline-variant/40 bg-surface-container-high px-4 py-2 text-xs font-bold text-black hover:bg-surface-container-highest transition cursor-pointer"
            >
              {state.isSaving ? 'Saving...' : 'Save & Continue'}
            </button>
            <button
              type="submit"
              disabled={state.isSaving}
              className="rounded-xl bg-primary px-5 py-2 text-xs font-bold text-white shadow-xs hover:bg-primary/90 transition cursor-pointer"
            >
              {state.isSaving ? 'Saving...' : 'Save & Exit'}
            </button>
          </>
        )}
      </div>
    </form>
  );
}
